export default function Colophon() {
  return (
    <footer data-testid="site-footer" className="border-t border-[#E5E5DE] py-8">
      <div className="max-w-[1200px] mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="text-[10px] tracking-[0.3em] uppercase text-[#6F6F63]">
          © 2026 eProcure Inc. — All Rights Reserved
        </p>
        <div className="flex flex-wrap justify-center gap-x-8 gap-y-2">
          <span className="text-[10px] tracking-[0.3em] uppercase text-[#6F6F63]">
            Mississauga, ON L5W 1X3
          </span>
        </div>
      </div>
    </footer>
  );
}
